module.exports = __webpack_public_path__ + "img/plan_c3.b2f76edd.webp";